import React, { useRef } from 'react';
import { useIntl } from 'react-intl';

import { Formik } from 'formik';

import CommonFormikDialog from 'components/Shared/CommonFormikDialog';
import SelectTechStack from '../SelectTechStack';

import { validatesArrayLength } from 'utils/formValidations';

const SkillsDialog = ({
    open,
    onClose,
    onSubmit,
    skills,
}) => {
    const intl = useIntl();

    const formikRef = useRef();

    const handleOnInputChangeSkill = (newValue) => {
        formikRef.current.setFieldValue('skills', [...formikRef.current.values.skills, { _id: newValue._id, name: newValue.title }]);
    };

    const handleOnDeleteSkill = (index) => {
        formikRef.current.setFieldValue('skills', [...formikRef.current.values.skills.slice(0, index), ...formikRef.current.values.skills.slice(index + 1)]);
    };

    const addNewSkill = (newValue) => {
        formikRef.current.setFieldValue('skills', [...formikRef.current.values.skills, { name: newValue, isNew: true }]);
    };

    return (
        <Formik
            innerRef={formikRef}
            enableReinitialize
            initialValues={{
                skills: [],
            }}
            validate={values => {
                return {
                    ...validatesArrayLength(values, 'skills', 1)
                }
            }}
            onSubmit={(values) => {
                const newSkills = values.skills.filter(skill => skills ? !skills.some(x => (x._id || x.name?.toLowerCase()) === skill._id) : true);

                onSubmit(newSkills);
                onClose();
            }}
        >
            {props => (
                <CommonFormikDialog
                    size="sm"
                    className="skill-dialog"
                    dialogTitle={intl.formatMessage({ id: "add-skills" })}
                    saveBtnText="save"
                    discardBtnText="discard"
                    open={open}
                    onClose={onClose}
                    onSave={props.handleSubmit}
                >
                    <form className="skills-dialog-view form" autoComplete="off">
                        <SelectTechStack
                            {...props}
                            label={intl.formatMessage({ id: "type-skill-name" })}
                            handleInputChange={handleOnInputChangeSkill}
                            handleOnDeleteSkill={handleOnDeleteSkill}
                            addNewSkill={addNewSkill}
                            technologies={props.values.skills.map(x => x.name)}
                            error={props.errors.skills && props.touched.skills ? props.errors.skills : ''}
                        />
                    </form>
                </CommonFormikDialog>
            )}
        </Formik>
    );
};

export default SkillsDialog;
